var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useContext, useState } from 'react';
import { ZdsBadge, ZdsButton, ZdsDivider, ZdsIcon, ZdsLink, ZdsModal, ZdsTab, ZdsTabs, } from '@zig-design-system/ui-components-react';
import { UnitContext } from '../../../context/UnitContext';
import CheckboxFilter from './CheckboxFilter';
import Alert, { AlertType } from '../../../../Shared/components/Alert';
import RadioFilter from './RadioFilter';
import Translation from '../../../../Shared/components/Translation';
import LoadingSpinner from '../../../../Shared/components/LoadingSpinner';
import PriceFilter from './PriceFilter';
import TextFilter from './TextFilter';
import LocationFilter from './LocationFilter';
const Filter = ({ filter, handleFilterChange, aggregations, activeFilters }) => {
    switch (filter.type) {
        case 'checkbox':
            return (React.createElement(CheckboxFilter, { activeFilters: activeFilters, filter: filter, handleFilterChange: handleFilterChange, aggregations: aggregations }));
        case 'radio':
            return React.createElement(RadioFilter, { filter: filter, handleFilterChange: handleFilterChange });
        case 'price':
            return (React.createElement(PriceFilter, { filter: filter, handleFilterChange: handleFilterChange, activeFilters: activeFilters }));
        case 'text':
            return React.createElement(TextFilter, { filter: filter, handleFilterChange: handleFilterChange, activeFilters: activeFilters });
        case 'location':
            return (React.createElement(LocationFilter, { filter: filter, handleFilterChange: handleFilterChange, activeFilters: activeFilters }));
        default:
            return (React.createElement(Alert, { message: 'Could not find correct filter to display type: ' + filter.type, type: AlertType.error }));
    }
};
const FilterGroup = ({ filterGroups, currentFilterGroup, handleChangeFilterGroup }) => {
    if (filterGroups.length === 1) {
        return null;
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(ZdsTabs, { className: "zds-block" }, filterGroups.map((filterGroup) => (React.createElement(ZdsTab, { active: currentFilterGroup === filterGroup ? true : undefined, key: filterGroup, onZdsTabActivate: handleChangeFilterGroup, "data-filter-group": filterGroup },
            React.createElement(Translation, { item: 'tx_zigrealestate.filter.heading.' + filterGroup }))))),
        React.createElement(ZdsDivider, { className: "zds-margin-y-0" })));
};
const isCheckedCheckbox = (checkbox) => {
    return checkbox.checked;
};
const Filters = () => {
    const { state, dispatch, viewport } = useContext(UnitContext);
    const [mobileFilterOpen, setMobileFilterOpen] = useState(false);
    const toggleMobileFilter = () => {
        setMobileFilterOpen(!mobileFilterOpen);
    };
    const handleFilterChange = () => {
        let filters = {};
        if (state.currentFilterGroup) {
            state.filters[state.currentFilterGroup].userFilters.forEach((filter) => {
                if (filter.type === 'checkbox') {
                    const checkedBoxes = Array.from(document.querySelectorAll(`#${filter.field} zds-checkbox`)).filter(isCheckedCheckbox);
                    checkedBoxes.forEach((checkedBox) => {
                        const filterQuery = checkedBox.name;
                        const currentFilterValue = filters[filterQuery];
                        const filterValue = checkedBox.value;
                        if (currentFilterValue) {
                            if (Array.isArray(currentFilterValue)) {
                                filters[filterQuery].push(filterValue);
                            }
                            else {
                                filters[filterQuery] = [currentFilterValue, filterValue];
                            }
                        }
                        else {
                            filters[filterQuery] = filterValue;
                        }
                    });
                }
                else if (filter.type === 'price') {
                    const priceFilter = document.querySelector(`#${filter.field} zds-range-slider`);
                    if (priceFilter === null || priceFilter === void 0 ? void 0 : priceFilter.value) {
                        const [min, max] = JSON.parse(priceFilter.value);
                        filters[filter.field + '_min'] = min;
                        filters[filter.field + '_max'] = max;
                    }
                }
                else if (filter.type === 'text') {
                    const textFilter = document.querySelector(`#${filter.field} zds-input-search`);
                    if (textFilter.value) {
                        filters[filter.field] = textFilter.value;
                    }
                }
                else if (filter.type === 'location') {
                    const locationFilter = document.querySelector(`#${filter.field} zds-advanced-select`);
                    state.filters[state.currentFilterGroup].userFilters.forEach((userFilter) => __awaiter(void 0, void 0, void 0, function* () {
                        if (userFilter.field === 'location') {
                            const locationFilterValues = yield locationFilter.getValue();
                            if (locationFilterValues.length === 0) {
                                return;
                            }
                            const optionsById = [];
                            userFilter.options.forEach((option) => {
                                optionsById[option.id] = option;
                            });
                            if (locationFilterValues.length === 1) {
                                const rangeFilter = document.querySelector(`#${filter.field} zds-select`);
                                const option = optionsById[locationFilterValues[0]['itemId']];
                                if (!(rangeFilter === null || rangeFilter === void 0 ? void 0 : rangeFilter.value) ||
                                    !option.additionalData.location.lng ||
                                    !option.additionalData.location.lat) {
                                    filters[option.filterQuery] = option.filterValue;
                                    return;
                                }
                                filters['location'] = {
                                    point: Object.assign({}, option.additionalData.location),
                                    distance: rangeFilter.value,
                                };
                            }
                            else {
                                locationFilterValues.forEach((filterValue) => {
                                    const option = optionsById[filterValue['itemId']];
                                    if (!filters[option.filterQuery]) {
                                        filters[option.filterQuery] = [];
                                    }
                                    filters[option.filterQuery].push(option.filterValue);
                                });
                            }
                        }
                    }));
                }
            });
        }
        dispatch({ type: 'changeUserFilter', value: filters });
    };
    const handleClearFilters = () => {
        document.querySelectorAll('#rentable-unit-list-filters zds-checkbox[checked="true"]').forEach((element) => {
            element['checked'] = false;
        });
        document.querySelectorAll('#rentable-unit-list-filters zds-input-search').forEach((element) => {
            element['value'] = '';
        });
        document.querySelectorAll('#rentable-unit-list-filters zds-select').forEach((element) => {
            element['value'] = '';
        });
        document.querySelectorAll('#rentable-unit-list-filters zds-advanced-select').forEach((element) => {
            element.clearValue();
        });
        dispatch({ type: 'resetUserFilters' });
    };
    const handleChangeFilterGroup = (e) => {
        const newFilterGroup = e.target.dataset.filterGroup;
        if (!newFilterGroup || newFilterGroup === state.currentFilterGroup) {
            return;
        }
        const groupFilter = {
            key: e.target.dataset.filterGroup,
        };
        state.filters[e.target.dataset.filterGroup].filters.forEach((filter) => {
            groupFilter[filter.filterQuery] = filter.filterValue;
        });
        dispatch({ type: 'changeGroupFilter', value: { groupFilter: groupFilter } });
    };
    const userFilterCount = () => {
        var _a, _b, _c, _d;
        let count = 0;
        for (const key in state.chosenUserFilters) {
            if (Array.isArray(state.chosenUserFilters[key])) {
                count += state.chosenUserFilters[key].length;
            }
            else {
                count++;
            }
        }
        // Price filter has two options; min and max. If both have the same value as the initial value we shouldn't increase the count
        state.filters[state.currentFilterGroup].userFilters.forEach((userFilter) => {
            if (userFilter.type === 'price') {
                let isEqualCounter = 0;
                userFilter.options.forEach((option) => {
                    var _a;
                    if (((_a = state.chosenUserFilters) === null || _a === void 0 ? void 0 : _a.hasOwnProperty(option.filterQuery)) &&
                        state.chosenUserFilters[option.filterQuery] == option.filterValue) {
                        isEqualCounter++;
                    }
                });
                if (isEqualCounter === 2) {
                    count--;
                }
            }
        });
        // Rent_min/selling_price_min and rent_max/selling_price_max count as 1 filter instead of 2
        if ((((_a = state.chosenUserFilters) === null || _a === void 0 ? void 0 : _a.hasOwnProperty('rent_min')) &&
            ((_b = state.chosenUserFilters) === null || _b === void 0 ? void 0 : _b.hasOwnProperty('rent_max'))) ||
            (((_c = state.chosenUserFilters) === null || _c === void 0 ? void 0 : _c.hasOwnProperty('selling_price_min')) &&
                ((_d = state.chosenUserFilters) === null || _d === void 0 ? void 0 : _d.hasOwnProperty('selling_price_max')))) {
            count--;
        }
        return count;
    };
    return (React.createElement(React.Fragment, null,
        state.filters && (React.createElement(FilterGroup, { filterGroups: Object.keys(state.filters), currentFilterGroup: state.currentFilterGroup, handleChangeFilterGroup: handleChangeFilterGroup })),
        React.createElement("div", { className: "zds-margin-top-4 md:zds-margin-y-4 zds-flex zds-justify-content-between zds-items-center" },
            React.createElement("div", { className: "zds-flex zds-items-center" },
                React.createElement(ZdsLink, { "icon-position": "start", className: "zds-bold md:zds-hidden", onZdsClick: toggleMobileFilter },
                    React.createElement(ZdsIcon, { name: "tune", slot: "icon", size: "md" }),
                    React.createElement("span", null,
                        React.createElement(Translation, { item: "tx_zigrealestate.filter.title" }))),
                React.createElement("div", { className: "zds-bold zds-hidden md:zds-flex zds-items-center" },
                    React.createElement(ZdsIcon, { size: "md", name: "tune", slot: "icon", className: "zds-margin-right-2" }),
                    React.createElement("span", null,
                        React.createElement(Translation, { item: "tx_zigrealestate.filters" }))),
                React.createElement(ZdsBadge, { class: "zds-margin-left-2", color: "grey-400" }, userFilterCount())),
            React.createElement(ZdsLink, { onZdsClick: handleClearFilters },
                React.createElement(Translation, { item: "tx_zigrealestate.filter.clear" }))),
        React.createElement(ZdsDivider, { className: "zds-hidden md:zds-block zds-margin-bottom-4" }),
        viewport === 'desktop' ? (React.createElement("div", { id: "rentable-unit-list-filters" }, state.filters && state.currentFilterGroup && (React.createElement(React.Fragment, null, state.filters[state.currentFilterGroup].userFilters.map((filter) => (React.createElement("div", { key: filter.field, className: "zds-margin-bottom-12" },
            React.createElement(Filter, { filter: filter, handleFilterChange: handleFilterChange, aggregations: state.aggregations, activeFilters: {
                    groupFilter: state.chosenGroupFilters,
                    userFilters: state.chosenUserFilters,
                } })))))))) : (React.createElement(ZdsModal, { open: mobileFilterOpen, fullscreen: true },
            React.createElement(ZdsButton, { preset: "muted", slot: "header-end", variant: "text", onZdsClick: toggleMobileFilter },
                React.createElement(ZdsIcon, { "aria-label": "close", name: "close", size: "lg" })),
            React.createElement("span", { slot: "header" },
                React.createElement(Translation, { item: "tx_zigrealestate.list_filter_mobile_header" })),
            React.createElement("div", { slot: "body", className: "zds-padding-8" }, state.loading ? (React.createElement(LoadingSpinner, { fullscreen: true })) : (React.createElement("div", { id: "rentable-unit-list-filters" }, state.filters && state.currentFilterGroup && (React.createElement(React.Fragment, null, state.filters[state.currentFilterGroup].userFilters.map((filter) => (React.createElement("div", { key: filter.field, className: "zds-margin-bottom-12" },
                React.createElement(Filter, { filter: filter, handleFilterChange: handleFilterChange, aggregations: state.aggregations, activeFilters: {
                        groupFilter: state.chosenGroupFilters,
                        userFilters: state.chosenUserFilters,
                    } }))))))))),
            React.createElement(ZdsButton, { className: "zds-margin-x-auto", preset: "secondary", slot: "footer", onZdsClick: toggleMobileFilter },
                React.createElement(Translation, { item: "tx_zigrealestate.show" }),
                " ",
                state.totalUnits + ' ',
                state.totalUnits === 1 ? (React.createElement(Translation, { item: "tx_zigrealestate.search.search_counter_result" })) : (React.createElement(Translation, { item: "tx_zigrealestate.search.search_counter_results" })))))));
};
export default Filters;
